import React from "react";
import { Accent, Container, SectionHeader } from "./ui";
import { bonuses } from "../data/content";
export function BonusesSection() {
  return <section className="bg-white py-12 md:py-20" data-id="element-14" data-mp="gxggu1cm8xjb">
      <Container data-id="element-15" data-mp="vt6402tjfgpm">
        <SectionHeader eyebrow="Included with your kit" title={<>
              5 practical bonuses <Accent data-id="element-17" data-mp="qsi3mqjf5niq">for the work around every activity</Accent>
            </>} lead="Prepare your materials, learn what residents enjoy and help your team lead with clear instructions." data-id="element-16" data-mp="vtnwqpgzrcss" />
        <div className="flex flex-wrap justify-center gap-5" data-id="element-18" data-mp="zsna8ygsghvu">
          {bonuses.map((b, i) => <article key={b.title} className="flex w-full flex-row overflow-hidden rounded-2xl border border-line bg-cream sm:w-[calc((100%-20px)/2)] sm:flex-col lg:w-[calc((100%-40px)/3)]" data-id="element-19" data-mp="1el8d8t3unupu" data-mpi={i}>
              <img src={b.src} alt={`${b.title} cover`} loading="lazy" className="h-auto w-[112px] shrink-0 self-stretch object-cover sm:aspect-[4/3] sm:w-full" data-id="element-20" data-mp="1jj0dcaenen54" />
              <div className="flex flex-1 flex-col p-4 sm:p-6" data-id="element-21" data-mp="3tsfcsnlcf7xh">
                <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-petrol" data-id="element-22" data-mp="2lcn60l5l9pd">
                  Bonus {i + 1}
                </p>
                <h3 className="mt-1 font-display text-xl font-bold uppercase leading-[1.05] text-ink sm:text-[24px]" data-id="element-23" data-mp="7im9v8h5r79i">
                  {b.title}
                </h3>
                <p className="mt-2 text-sm text-muted sm:text-[15px]" data-id="element-24" data-mp="gkc3mkyiiiag">{b.benefit}</p>
              </div>
            </article>)}
        </div>
      </Container>
    </section>;
}